// import React from 'react';
// import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from 'react-icons/fa';
// import './Footer.css';

// const Footer = () => {
//   return (
//     <footer>
//       <div className="footer-container">
//         {/* Column 1 - About */}
//         <div className="footer-about">
//           <div className="footer-logo">
//             <h2>HELP<span>io</span></h2>
//           </div>
//           <p>
//             Your ultimate destination for seamless connections between users and service providers.
//             Experience the ease of accessing essential services on a single platform.
//           </p>
//           <div className="social-icons">
//             <a href="https://www.facebook.com" className="social-icon" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
//             <a href="https://www.twitter.com" className="social-icon" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
//             <a href="https://www.linkedin.com" className="social-icon" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
//             <a href="https://www.instagram.com" className="social-icon" target="_blank" rel="noopener noreferrer"> <FaInstagram /></a>
//           </div>
//         </div>

//         {/* Column 2 - Quick Links */}
//         <div className="footer-links-container">
//           <h3 className="footer-heading">Quick Links</h3>
//           <ul className="footer-links">
//             <li><a href="/">Home</a></li>
//             <li><a href="/">Services</a></li>
//             <li><a href="/about">About Us</a></li>
//             <li><a href="/">Contact</a></li>
//             <li><a href="/">Blog</a></li>
//             <li><a href="/">Privacy Policy</a></li>
//           </ul>
//         </div>

//         {/* Column 3 - Our Services */}
//         <div className="footer-links-container">
//           <h3 className="footer-heading">Our Services</h3>
//           <ul className="footer-links">
//             <li><a href="/services/electrician">Electrician</a></li>
//             <li><a href="/services/home-cleaning">Home Cleaning</a></li>
//             <li><a href="/services/plumber">Plumber</a></li>
//             <li><a href="/services/home-shifting">Home Shifting</a></li>
//             <li><a href="/services/application-maintenance">Application Maintenance</a></li>
//             <li><a href="/services/house-painting">House Painting</a></li>
//           </ul>
//         </div>

//         {/* Column 4 - Contact Info */}
//         <div className="contact-container">
//           <h3 className="footer-heading">Contact Us</h3>
//           <ul className="contact-info">
//             <li><i>📍</i> 123 Service Street, City, Country</li>
//             <li><i>📞</i> +1 234 567 8900</li>
//             <li><i>✉️</i> support@HelpNao.com</li>
//             <li><i>⏰</i> Monday-Friday: 9am to 5pm</li>
//           </ul>
//         </div>

//         {/* Column 5 - Newsletter */}
//         <div className="newsletter">
//           <h3 className="footer-heading">Newsletter</h3>
//           <p>Subscribe to our newsletter for updates and offers.</p>
//           <input type="email" placeholder="Enter your email" />
//           <button>Subscribe</button>
//         </div>
//       </div>

//       <div className="footer-bottom">
//         <p>
//           &copy; 2025 HelpNao. All rights reserved. Designed with ❤️ for better service connections.
//         </p>
//       </div>
//     </footer>
//   );
// };

// export default Footer;












import React, { useMemo } from "react";
import {
  FaFacebookF,
  FaYoutube,
  FaLinkedinIn,
  FaInstagram,
} from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarkerAlt,
  faPhone,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import "./Footer.css";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const isTokenValid = (token) => {
  try {
    if (!token) return false;
    const decoded = jwtDecode(token);
    // If no exp, treat as valid (depends on your backend)
    if (!decoded?.exp) return true;
    return decoded.exp * 1000 > Date.now();
  } catch {
    return false;
  }
};

const Footer = () => {
  const { t } = useTranslation();

  const ICON = {
    location: faMapMarkerAlt,
    phone: faPhone,
    email: faEnvelope,
  };


  const isLoggedIn = useMemo(() => {
    const token = localStorage.getItem("token");
    const ok = isTokenValid(token);
    if (!ok && token) localStorage.removeItem("token");
    return ok;
  }, []);

  return (
    <footer>
      <div className="footer-container">
        {/* Column 1 - About */}
        <div className="footer-about">
          <div className="footer-logo">
            {/* <h2 dangerouslySetInnerHTML={{ __html: t('footer.logo') }} /> */}
            <h2>
              Help<span>Nao</span>
            </h2>
          </div>
          <p>{t("footer.about")}</p>
          <div className="social-icons">
            <a
              href="https://www.facebook.com/profile.php?id=61581903921697"
              className="social-icon"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.youtube.com/@HelpNao"
              className="social-icon"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
              title="YouTube"
            >
              <FaYoutube />
            </a>
            <a
              href="https://www.linkedin.com"
              className="social-icon"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedinIn />
            </a>
            <a
              href="https://www.instagram.com"
              className="social-icon"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>
          </div>
        </div>

        {/* Column 2 - Quick Links */}
        <div className="footer-links-container">
          <h3 className="footer-heading">{t("footer.quick_links")}</h3>
          <ul className="footer-links">
            <li>
              <Link to="/">{t("footer.home")}</Link>
            </li>
            {/* Guest-only links (match Navbar behavior) */}
            {!isLoggedIn && (
              <>
                <li>
                  <Link to="/earnwithHelpNao">{t("footer.services")}</Link>
                </li>
                <li>
                  <Link to="/about">{t("footer.about_us")}</Link>
                </li>
              </>
            )}

            {/* Logged-in links */}
            {isLoggedIn && (
              <>
                <li>
                  <Link to="/profile">{t("footer.profile") || "Profile"}</Link>
                </li>
                <li>
                  <Link to="/profile/orderhistory">
                    {t("footer.my_orders") || "My Orders"}
                  </Link>
                </li>
              </>
            )}
            <li>
              <Link to="/contact">{t("footer.contact")}</Link>
            </li>
            <li>
              <Link to="/helpfaqs">{t("footer.blog")}</Link>
            </li>
            <li>
              <Link to="/legal/terms-and-privacy">
                {t("footer.privacy_policy")}
              </Link>
            </li>
          </ul>
        </div>

        {/* Column 3 - Our Services */}
        <div className="footer-links-container">
          <h3 className="footer-heading">{t("footer.our_services")}</h3>
          <ul className="footer-links">
            <li>
              <Link to="/services/electrician">{t("footer.electrician")}</Link>
            </li>
            <li>
              <Link to="/services/plumber">{t("footer.plumber")}</Link>
            </li>
            <li>
              <Link to="/services/gas-chula">{t("footer.gas_chula")}</Link>
            </li>
            <li>
              <Link to="/services/ac-service">{t("footer.ac_service")}</Link>
            </li>
            {/* <li><a href="/services/filter">{t('footer.filter')}</a></li> */}
            {/* <li><a href="/services/tutor-service">{t('footer.tutor_service')}</a></li> */}
          </ul>
        </div>

        {/* Column 4 - Contact Info */}
        <div className="contact-container">
          <h3 className="footer-heading">{t("footer.contact_us")}</h3>
          <ul className="contact-info">
            <li>
              {/* <i className="fas fa-map-marker-alt"></i>  */}
              <FontAwesomeIcon icon={ICON.location} aria-hidden="true" />
              {t("footer.address")}
            </li>
            <li>
              {/* <i className="fas fa-phone"></i>  */}
              <FontAwesomeIcon icon={ICON.phone} aria-hidden="true" />
              {t("footer.phone")}
            </li>
            <li>
              {/* <i className="fas fa-envelope"></i>  */}
              <FontAwesomeIcon icon={ICON.email} aria-hidden="true" />
              {t("footer.email")}
            </li>
            {/* <li><i className="fas fa-clock"></i> {t('footer.hours')}</li> */}
          </ul>
        </div>

        {/* Column 5 - Newsletter */}
        {/* <div className="newsletter">
          <h3 className="footer-heading">{t('footer.newsletter')}</h3>
          <p>{t('footer.newsletter_description')}</p>
          <input type="email" placeholder={t('footer.newsletter_placeholder')} />
          <button>{t('footer.subscribe')}</button>
        </div> */}
      </div>

      <div className="footer-bottom">
        <p>{t("footer.copyright")}</p>
      </div>
    </footer>
  );
};

export default Footer;








